import { takeEvery, call, put } from "redux-saga/effects";
import { replace } from "react-router-redux";
import axios from "axios";
import queryString from "qs";
import { AppActions } from "../actions";
import { RouteUrls } from "../configs/routeUrls";
import {
  ThematicAreaDropdownOption,
  ProjectType,
  ProjectMode,
  VoteMode,
} from "../utils/enums";

export function* watchGetDefaultSmtpConfiguration() {
  yield takeEvery(
    AppActions.GetDefaultSmtpConfigurationAction.Request,
    getDefaultSmtpConfiguration
  );
}

function* getDefaultSmtpConfiguration() {
  try {
    let smtpConfiguration = yield call(getDefaultSmtpConfigurationRequest);

    yield put({
      type: AppActions.GetDefaultSmtpConfigurationAction.Success,
      payload: smtpConfiguration,
    });
  } catch (err) {
    yield put({
      type: AppActions.GetDefaultSmtpConfigurationAction.Failure,
    });
  }
}

function getDefaultSmtpConfigurationRequest() {
  return axios
    .get(`/api/app/smtp`)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
}

export function* watchFetchPermissions() {
  yield takeEvery(AppActions.FetchPermissionsAction.Request, fetchPermissions);
}

function* fetchPermissions() {
  try {
    let permissions = yield call(getPermissionsRequest);

    yield put({
      type: AppActions.FetchPermissionsAction.Success,
      payload: permissions,
    });
  } catch (err) {
    yield put({
      type: AppActions.FetchPermissionsAction.Failure,
    });
  }
}

function getPermissionsRequest() {
  return axios
    .get(`/api/app/permissions`)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
}

export function* watchGetRoles() {
  yield takeEvery(AppActions.FetchRolesAction.Request, fetchRoles);
}

function* fetchRoles() {
  try {
    let roles = yield call(getRolesRequest);

    yield put({
      type: AppActions.FetchRolesAction.Success,
      payload: roles,
    });
  } catch (err) {
    yield put({
      type: AppActions.FetchRolesAction.Failure,
    });
  }
}

function getRolesRequest() {
  return axios
    .get(`/api/app/roles`)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
}

export function* watchGetInitData() {
  yield takeEvery(AppActions.GetInitDataAction.Request, getInitData);
}

function* getInitData() {
  try {
    let initData = yield call(getInitDataRequest);

    yield put({
      type: AppActions.GetInitDataAction.Success,
      payload: initData,
    });
  } catch (err) {
    yield put({
      type: AppActions.GetInitDataAction.Failure,
    });
  }
}

function getInitDataRequest() {
  return axios
    .get(`/api/app/init-data`)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
}

export function* watchSearchProject() {
  yield takeEvery(AppActions.SearchProjectAction.Request, searchProject);
}

function* searchProject(action) {
  try {
    let searchListItems = yield call(searchProjectRequest, action.payload);

    yield put({
      type: AppActions.SearchProjectAction.Success,
      payload: searchListItems,
    });
    let searchTermFilter = action.payload
      ? `?${queryString.stringify(action.payload, { skipNulls: true })}`
      : "";
    yield put(replace(`${RouteUrls.App.searchList}${searchTermFilter}`));
  } catch (err) {
    yield put({
      type: AppActions.SearchProjectAction.Failure,
    });
  }
}

function searchProjectRequest(search) {
  search.voteMode =
    search.voteMode !== VoteMode.NotSetted && search.voteMode != undefined
      ? search.voteMode
      : null;
  search.projectMode =
    search.projectMode !== ProjectMode.NotSetted &&
    search.projectMode != undefined
      ? search.projectMode
      : null;
  search.projectType =
    search.projectType !== ProjectType.NotSetted &&
    search.projectType != undefined
      ? search.projectType
      : null;
  search.category =
    search.category !== ThematicAreaDropdownOption.NotSetted &&
    search.category != undefined
      ? search.category
      : null;
  const query = queryString.stringify(search, { skipNulls: true });

  return axios
    .get(`/api/search?${query}`)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
}

export function* watchGetMainPageProjects() {
  yield takeEvery(
    AppActions.GetMainPageProjectsAction.Request,
    getMainPageProjects
  );
}

function* getMainPageProjects() {
  try {
    let initData = yield call(getMainPageProjectsRequest);

    yield put({
      type: AppActions.GetMainPageProjectsAction.Success,
      payload: initData,
    });
  } catch (err) {
    yield put({
      type: AppActions.GetMainPageProjectsAction.Failure,
    });
  }
}

function getMainPageProjectsRequest() {
  return axios
    .get(`/api/app/main-page-projects`)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
}

export function* watchGetTermsOfUse() {
  yield takeEvery(AppActions.GetTermsOfUseAction.Request, getTermsOfUse);
}

function* getTermsOfUse(action) {
  try {
    let termsOfUse = yield call(getTermsOfUseRequest, action.payload);

    yield put({
      type: AppActions.GetTermsOfUseAction.Success,
      payload: termsOfUse,
    });
  } catch (err) {
    yield put({
      type: AppActions.GetTermsOfUseAction.Failure,
    });
  }
}

function getTermsOfUseRequest(id) {
  return axios
    .get(`/api/app/terms-of-use/${id}`)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
}

export function* watchUnloadApp() {
  yield takeEvery(AppActions.UnloadAppAction.Request, unloadApp);
}

function* unloadApp() {
  yield put({
    type: AppActions.UnloadAppAction.Success,
  });
}

export function* watchSetPageSize() {
  yield takeEvery(AppActions.SetPageSizeAction.Request, setPageSize);
}

function* setPageSize(action) {
  yield put({
    type: AppActions.SetPageSizeAction.Success,
    payload: action.payload,
  });
}

export function* watchGetApplicationImages() {
  yield takeEvery(
    AppActions.GetApplicationImagesAction.Request,
    getApplicationImages
  );
}

function* getApplicationImages() {
  try {
    let images = yield call(getApplicationImagesRequest);

    yield put({
      type: AppActions.GetApplicationImagesAction.Success,
      payload: images,
    });
  } catch (err) {
    yield put({
      type: AppActions.GetApplicationImagesAction.Failure,
    });
  }
}

function getApplicationImagesRequest(id) {
  return axios
    .get(`/api/app/images`)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
}

export function* watchSetArchivePageSize() {
  yield takeEvery(
    AppActions.SetArchivePageSizeAction.Request,
    setArchivePageSize
  );
}

function* setArchivePageSize(action) {
  yield put({
    type: AppActions.SetArchivePageSizeAction.Success,
    payload: action.payload,
  });
}

export function* watchGetMainPageProbeProjects() {
  yield takeEvery(
    AppActions.GetMainPageProbeProjectsAction.Request,
    getMainPageProbeProjects
  );
}

function* getMainPageProbeProjects() {
  try {
    let initData = yield call(getMainPageProbeProjectsRequest);

    yield put({
      type: AppActions.GetMainPageProbeProjectsAction.Success,
      payload: initData,
    });
  } catch (err) {
    yield put({
      type: AppActions.GetMainPageProbeProjectsAction.Failure,
    });
  }
}

function getMainPageProbeProjectsRequest() {
  return axios
    .get(`/api/app/main-page-probe-projects`)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
}

export function* watchSetExpandStateItem() {
  yield takeEvery(
    AppActions.SetExpandStateItemAction.Request,
    setExpandStateItem
  );
}

function* setExpandStateItem(action) {
  yield put({
    type: AppActions.SetExpandStateItemAction.Success,
    payload: { ...action.payload },
  });
}

export function* watchSetBreadcrumbs() {
  yield takeEvery(AppActions.SetBreadcrumbsAction.Request, setBreadcrumbs);
}

function* setBreadcrumbs(action) {
  yield put({
    type: AppActions.SetBreadcrumbsAction.Success,
    payload: action.payload,
  });
}
